module.exports = __webpack_public_path__ + "media/images/icons/biology_icon-758abde8aa901c8686cc5e2cdbea0373.svg";